import React, { ComponentProps } from 'react'
import { FieldIconUi } from './ui/field-icon-ui'

interface FieldIconProps extends ComponentProps<typeof FieldIconUi> {}

export const FieldIconNew = (props: FieldIconProps) => {
  return <FieldIconUi {...props} />
}
